/*
 * @Author: 李旭
 * @Date: 2022-09-08 11:19:25
 * @LastEditTime: 2022-09-08 15:16:55
 * @LastEditors: 李旭
 * @Description: 群居字典表
 *
 */
import { useState, useCallback, useEffect } from 'react';
import { useModel } from 'umi';
import { getDicList } from '@/services/global';
type SpecificationItem = {
  dicId: string;
  dicKey: string;
  dicName:string;
};
export default () => {
  const [dic, handleDic] = useState<SpecificationItem[] | []>([]);
  const { initialState } = useModel('@@initialState');
  useEffect(() => {
    if (initialState?.currentUser) {
      console.log('-------查询字典-------');
      // getDicList().then((res: any) => {
      //   console.log(res);
      //   if (res.code == '00000') {
      //     handleDic(res.result);
      //   }
      // });
    }
  }, [initialState?.currentUser]);

  const setDic = useCallback((data: Array<SpecificationItem>) => {
    handleDic(data);
  }, []);

  const getDicItem = useCallback((type: string): SpecificationItem[] | [] => {
    const Item = dic.filter((item) => item.dicKey == type);
    if (Item.length == 0) {
      return [];
    } else {
      return Item;
    }
  }, [dic]);

  return { dic,setDic, getDicItem };
};
